import { color } from "@styles";
import { types } from "react-bricks";

export const backgroundColorProp = {
  name: "backgroundColor",
  label: "Background Color",
  type: types.SideEditPropType.Select,
  shouldRefreshStyles: true,
  selectOptions: {
    display: types.OptionsDisplay.Color,
    options: [
      { value: { color: color.S410 }, label: "Yellow" },
      { value: { color: color.S210 }, label: "Blue" },
      { value: { color: color.S310 }, label: "S3100" },
      { value: { color: color.S110 }, label: "S1100" },
      { value: { color: color.B210 }, label: "B210" },
      { value: { color: color.white }, label: "White" },
    ],
  },
};
